/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { RuleScriptEntity } from './RuleScriptEntity.js';
import {
    RuleScriptEntityFromJSON,
    RuleScriptEntityFromJSONTyped,
    RuleScriptEntityToJSON,
} from './RuleScriptEntity.js';
import type { RuleType } from './RuleType.js';
import {
    RuleTypeFromJSON,
    RuleTypeFromJSONTyped,
    RuleTypeToJSON,
} from './RuleType.js';

/**
 * 
 * @export
 * @interface RuleEntity
 */
export interface RuleEntity {
    /**
     * 
     * @type {number}
     * @memberof RuleEntity
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleEntity
     */
    scorecardTemplateId?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleEntity
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof RuleEntity
     */
    maxScore?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleEntity
     */
    order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEntity
     */
    isManual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEntity
     */
    isScriptAdherence?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEntity
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {RuleType}
     * @memberof RuleEntity
     */
    type?: RuleType;
    /**
     * 
     * @type {Date}
     * @memberof RuleEntity
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RuleEntity
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEntity
     */
    isDraft?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RuleEntity
     */
    sectionId?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleEntity
     */
    sectionName?: string;
    /**
     * 
     * @type {RuleScriptEntity}
     * @memberof RuleEntity
     */
    script?: RuleScriptEntity;
    /**
     * 
     * @type {string}
     * @memberof RuleEntity
     */
    scriptJson?: string;
}

/**
 * Check if a given object implements the RuleEntity interface.
 */
export function instanceOfRuleEntity(value: object): boolean {
    return true;
}

export function RuleEntityFromJSON(json: any): RuleEntity {
    return RuleEntityFromJSONTyped(json, false);
}

export function RuleEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scorecardTemplateId': json['scorecardTemplateId'] == null ? undefined : json['scorecardTemplateId'],
        'name': json['name'] == null ? undefined : json['name'],
        'maxScore': json['maxScore'] == null ? undefined : json['maxScore'],
        'order': json['order'] == null ? undefined : json['order'],
        'isManual': json['isManual'] == null ? undefined : json['isManual'],
        'isScriptAdherence': json['isScriptAdherence'] == null ? undefined : json['isScriptAdherence'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'type': json['type'] == null ? undefined : RuleTypeFromJSON(json['type']),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
        'sectionName': json['sectionName'] == null ? undefined : json['sectionName'],
        'script': json['script'] == null ? undefined : RuleScriptEntityFromJSON(json['script']),
        'scriptJson': json['scriptJson'] == null ? undefined : json['scriptJson'],
    };
}

export function RuleEntityToJSON(value?: RuleEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scorecardTemplateId': value['scorecardTemplateId'],
        'name': value['name'],
        'maxScore': value['maxScore'],
        'order': value['order'],
        'isManual': value['isManual'],
        'isScriptAdherence': value['isScriptAdherence'],
        'isGlobal': value['isGlobal'],
        'type': RuleTypeToJSON(value['type']),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isDraft': value['isDraft'],
        'sectionId': value['sectionId'],
        'sectionName': value['sectionName'],
        'script': RuleScriptEntityToJSON(value['script']),
        'scriptJson': value['scriptJson'],
    };
}

